import React, { lazy, Suspense } from "react";
import "./App.css";
import { Routes, Route } from "react-router-dom";
import ScrollToTop from "./components/ScrollToTop";
import Navbar from "./components/Navbar";
import HeroSection from "./components/HeroSection";
import ServicesSection from "./components/ServicesSection";
import TourPackagesSection from "./components/TourPackagesSection";

import RoutesSection from "./components/RoutesSection";
import FleetSection from "./components/FleetSection";
import WhyChooseSection from "./components/WhyChooseSection";
import BookingCTA from "./components/BookingCTA";
import ContactSection from "./components/ContactSection";
import Footer from "./components/Footer";
import FloatingCTA from "./components/FloatingCTA";
import ReviewsSection from "./components/ReviewsSection";

// Lazy load secondary routes to optimize initial bundle size
const UdaipurSightseeing = lazy(() => import("./pages/UdaipurSightseeing"));
const TourDetailPage = lazy(() => import("./pages/TourDetailPage"));
const Gallery = lazy(() => import("./pages/Gallery"));
const RouteDetail = lazy(() => import("./pages/RouteDetail"));
const AboutUs = lazy(() => import("./pages/AboutUs"));
const PrivacyPolicy = lazy(() => import("./pages/PrivacyPolicy"));
const TermsAndConditions = lazy(() => import("./pages/TermsAndConditions"));
const Disclaimer = lazy(() => import("./pages/Disclaimer"));
const Support = lazy(() => import("./pages/Support"));

const PageLoading = () => (
  <div className="min-h-[60vh] flex flex-col items-center justify-center bg-[#0a0a0c] text-white">
    <div className="w-12 h-12 border-4 border-amber-500 border-t-transparent rounded-full animate-spin mb-4" />
    <p className="text-amber-500 text-xs font-black uppercase tracking-[0.25em]">Loading Bahubali Experience...</p>
  </div>
);

function HomePage() {
  return (
    <>
      <HeroSection />
      <ServicesSection />
      <TourPackagesSection />
      <RoutesSection />
      <FleetSection />
      <WhyChooseSection />
      <BookingCTA />
      <ContactSection />
      <ReviewsSection />
    </>
  );
}

function App() {
  return (
    <div className="App">
      <ScrollToTop />
      <Navbar />

      <Suspense fallback={<PageLoading />}>
        <Routes>
          <Route path="/" element={<HomePage />} />
          <Route path="/udaipur-sightseeing" element={<UdaipurSightseeing />} />
          <Route path="/tours/:slug" element={<TourDetailPage />} />
          <Route path="/gallery" element={<Gallery />} />
          <Route path="/routes/:slug" element={<RouteDetail />} />
          <Route path="/about-us" element={<AboutUs />} />
          <Route path="/privacy-policy" element={<PrivacyPolicy />} />
          <Route path="/terms-and-conditions" element={<TermsAndConditions />} />
          <Route path="/disclaimer" element={<Disclaimer />} />
          <Route path="/support" element={<Support />} />
        </Routes>
      </Suspense>

      <Footer />
      <FloatingCTA />
    </div>
  );
}

export default App;
